import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { calculateTimeAgo } from "utils/news/calculateTimeAgo";
import "./NewsBlockItem.css";

const NewsBlockItem = ({ item }) => {
  const newsItemWrapperStyles = {
    backgroundImage: `url(https://ipscore.app${item.main_img_en})`,
  };

  const navigate = useNavigate();

  const handleArticleClick = () => {
    navigate(`/news/${item.short_uri_en}`);
  };

  let timeMessage;
  const intl = useIntl();
  const daysAgo = calculateTimeAgo(item.post_date).daysAgo;
  if (daysAgo < 1) {
    timeMessage = intl.formatMessage({
      id: "todayMessage",
      defaultMessage: "today",
    });
  } else if (daysAgo >= 30) {
    timeMessage = intl.formatMessage(
      {
        id: "monthsAgoMessage",
        defaultMessage: "todayMessage",
      },
      { monthsAgo: Math.floor(daysAgo / 30) }
    );
  } else if (daysAgo >= 7) {
    timeMessage = intl.formatMessage(
      {
        id: "weeksAgoMessage",
        defaultMessage: "{weeksAgo, plural, one {# week} other {# weeks}} ago",
      },
      { weeksAgo: Math.floor(daysAgo / 7) }
    );
  } else {
    timeMessage = intl.formatMessage(
      {
        id: "daysAgoMessage",
        defaultMessage: "{daysAgo, plural, one {# day} other {# days}} ago",
      },
      { daysAgo }
    );
  }

  return (
    <div
      className="news-item-wrapper"
      style={newsItemWrapperStyles}
      onClick={handleArticleClick}
    >
      <div className="opacity-block"></div>
      <div className="news-bottom-area">
        <div className="news-info">
          <p className="news-info-text">
            <FormattedMessage id="NewsNavbarText" />
          </p>
          <p className="news-info-text">
            <FormattedMessage id="PublishedText" /> {`${timeMessage}`}
          </p>
        </div>
        <h2 className="news-title">{item.title_en}</h2>
      </div>
    </div>
  );
};

export default NewsBlockItem;